<template>
  <router-view />
  <dice-roller-plugin
    v-if="!($route && $route.query && ($route.query.noDice || $route.query.embed))"
  />
  <AiChatButton v-if="!($route && $route.query && ($route.query.embed || $route.query.noUi))" />
  <AvatarChatSfuProvider
    v-if="!($route && $route.query && ($route.query.embed || $route.query.noUi))"
  />
</template>

<script>
  import { defineComponent } from 'vue'
  import DiceRollerPlugin from './components/plugins/GlobalDiceRoller/components/DiceRollerPlugin.vue'
  import AvatarChatSfuProvider from './components/plugins/AvatarChat/sfu/components/AvatarChatSfuProvider.vue'
  import AiChatButton from './components/plugins/AiChat/AiChatButton.vue'

  export default defineComponent({
    name: 'App',
    components: {
      DiceRollerPlugin,
      AvatarChatSfuProvider,
      AiChatButton
    }
  })
</script>
